import React from 'react';
import { TransitionProps } from '@material-ui/core/transitions';
import { Zoom, Grow, Slide, Fade, Collapse } from "@material-ui/core";

//#region TransitionProp for Dialog
export function transition(type:string) {
  let TransitionProp:any;
  switch (type) {
    case "Zoom":
      TransitionProp = React.forwardRef(function Transition(props:TransitionProps, ref:React.Ref<unknown>) {
        return <Zoom ref={ref} {...props} />;
      });
      break;
    case "Grow":
      TransitionProp = React.forwardRef(function Transition(props:TransitionProps, ref:React.Ref<unknown>) {
        return <Grow ref={ref} {...props} />;
      });
      break;
    case "Fade":
      TransitionProp = React.forwardRef(function Transition(props:TransitionProps, ref:React.Ref<unknown>) {
        return <Fade ref={ref} {...props} />;
      });
      break;
    case 'Collapse':
      TransitionProp = React.forwardRef(function Transition(props:TransitionProps, ref:React.Ref<unknown>) {
        return <Collapse ref={ref} {...props} />;
      });
      break;
    default:
      TransitionProp = React.forwardRef(function Transition(props:TransitionProps, ref:React.Ref<unknown>) {
        return <Slide direction="up" ref={ref} {...props} />;
      });
      break;
  }
  return TransitionProp;
}
  //#endregion

//#region Time Formatter
  // returns day start(hrs)-end(hrs) Uhr
// export const formatTime = (startDate:string, endDate:string) => {  
//   let sDate = new Date(Date.parse(startDate));
//   let eDate = new Date(Date.parse(endDate));
//   return (sDate.getUTCHours()<10?'0'+sDate.getUTCHours().toString():sDate.getUTCHours().toString())+'-'
//   +(eDate.getUTCHours()<10?'0'+eDate.getUTCHours().toString():eDate.getUTCHours().toString()) + ' Uhr';
// }
export const formatTime = (startDate:string, endDate:string) => {  
  return `${getGermanHours(startDate)} - ${getGermanHours(endDate)} Uhr`;
}

//#endregion

//#region date Formatter
/* Paarms
date: date Object
returns formatted date -> dd.mm.yyyy
*/
export const formatDate = (appointmentDate:string) => {
  let aDate = new Date(Date.parse(appointmentDate));
  const days = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  const apointmentDay = aDate.getUTCDate()<10?'0'+aDate.getUTCDate().toString():aDate.getUTCDate();
  const appointmentMonth = aDate.getUTCMonth()<9?'0'+(aDate.getUTCMonth()+1).toString():(aDate.getUTCMonth()+1).toString();
  const appointmentYear = aDate.getUTCFullYear();
  return days[aDate.getUTCDay()]+' '+apointmentDay+'.'+appointmentMonth+'.'+appointmentYear;
}
//#endregion

//#region Tealium
export async function tealiumDataLayerPush(eventType:String, error:Object, layOver:Object, pageView:Object={siteStructureElement:[]}, microConversion:Object):Promise<any>{
  var dl:Object;
  if(eventType.toLowerCase() === 'pageview'){
    dl = {
      siteStructure: [
        "micropages", 
        "my incident tickets"
      ].concat(pageView['siteStructureElement']),
      loginStatus: "not logged in",
      pageType: "service",
      siteArea: "micropages",
      platformType: "responsive"
    };
    if (Object.keys(error).length > 0) {
      const errorPage = { error: error }
      dl = Object.assign(dl, errorPage);
    }
  } else if(eventType.toLowerCase() === 'error') {
    dl = {
      type : error['type'],
      message : error['message'],
      location : error['location']
    }
  } else if(eventType.toLowerCase() === 'layover') {
    dl = {
      action : 'show',
      name : layOver['name']
    }
  } else if(eventType.toLowerCase() === 'micro conversion') {
    dl = {
      micro_conversion_category: microConversion['category'],
      micro_conversion_name: microConversion['name']
    }
  }
  var _ddq = window['_ddq'] || (window['_ddq'] = []);
  _ddq.push([eventType, dl]);
  return new Promise((resolve, reject)=>{
    resolve('pushed lata Layer Object');
  });
}
//#endregion

function getGermanHours (date:string):String{
  return new Date(date).toLocaleTimeString('en-DE',{timeZone:'Europe/Berlin'}).split(':')[0];
}


export async function checkImage(url, alt){     
  const res = await fetch(url);
  // console.log(res);
  const buff = await res.blob();
  return buff.type.startsWith('image/')?url:alt;
}

export function checkImageb(url) {
  var request = new XMLHttpRequest();
  var resp;
  request.open("GET", url, true);
  request.send();
  request.onload = () => {
    if (request.status == 200) //if(statusText == OK)
    {
      resp = true;
      return true;
    } else {
      resp=false
      return false;
    }
  }
  return resp;
}